import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { colors } from "./source.styles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ArchiveConfirmationModal = ({ open, onClose, onConfirm, sourceName }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          p: 2,
        },
      }}
    >
      {/* Content */}
      <DialogContent sx={{ textAlign: "center", pt: 4, pb: 3 }}>
        {/* Warning Icon */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "#FEE2E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 3,
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 32, color: "#DC2626" }} />
        </Box>

        {/* Title */}
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 700,
            color: colors.textPrimary,
            mb: 2,
          }}
        >
          Archive "{sourceName}"?
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: colors.textSecondary,
            lineHeight: 1.6,
          }}
        >
          Are you sure you want to archive this source? It will no longer appear in active reports but can be restored from the Archive settings.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          pb: 3,
          px: 3,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            fontSize: 13,
            fontWeight: 600,
            textTransform: "none",
            color: colors.textSecondary,
            borderColor: colors.borderLight,
            px: 4,
            py: 1,
            borderRadius: 2,
            "&:hover": {
              borderColor: colors.border,
              bgcolor: colors.bgPrimary,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            fontSize: 13,
            fontWeight: 600,
            textTransform: "none",
            bgcolor: "#DC2626",
            color: "#FFF",
            px: 4,
            py: 1,
            borderRadius: 2,
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#B91C1C",
              boxShadow: "none",
            },
          }}
        >
          Archive Source
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveConfirmationModal;
